export class BreadcrumbService {
  private breadcrumbs: Array<InterACT.Interfaces.IBreadcrumb>;
  constructor() {
    this.resetBreadcrumbs();
  }

  /**
   * Sets the breadcrumbs of the toolbar
   * @param breadcrumbs the breadcrumbs of the toolbar
   */
  public setBreadcrumbs(breadcrumbs: Array<InterACT.Interfaces.IBreadcrumb>) {
    breadcrumbs.forEach((breadcrumb) => {
      if (breadcrumb.params) {
        breadcrumb.sref += '(breadcrumb.params)';
      }
    });

    this.breadcrumbs = breadcrumbs;
  }

  /**
   * Adds a new breadcrumb
   * @param breadcrumb the breadcrumb to add
   */
  public addBreadcrumb(breadcrumb: InterACT.Interfaces.IBreadcrumb) {
    if (breadcrumb.params) {
      breadcrumb.sref += '(breadcrumb.params)';
    }
    this.breadcrumbs.push(breadcrumb);
  }

  /**
   * Removes the last breadcrumb from the breadcrumb list
   */
  public removeLastBreadcrumb() {
    this.breadcrumbs.pop();
  }

  /**
   * Gets the list of breadcrumbs
   * @returns the list of breadcrumbs
   */
  public getBreadcrumbs() {
    return this.breadcrumbs;
  }

  /**
   * Resets the list of breadcrumbs
   */
  public resetBreadcrumbs() {
    this.breadcrumbs = [];
  }
}